import { render, staticRenderFns } from "./vcModalDialog.vue?vue&type=template&id=3b690b06&scoped=true&"
import script from "./vcModalDialog.vue?vue&type=script&lang=js&"
export * from "./vcModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b690b06",
  null
  
)

export default component.exports